import {useEffect, useState} from 'react';
import {BBOX} from '../../types/commonTypes';
import {getLayerBbox} from '../../utils/wmsLayers';

const useDataExtent = (): BBOX | undefined => {
  const [dataExtent, setDataExtent] = useState<BBOX>();
  useEffect(() => {
    getLayerBbox('irriter:landparcel').then(setDataExtent);
  }, []);
  return dataExtent;
};

export default useDataExtent;
